import { render, staticRenderFns } from "./IconTextFile.vue?vue&type=template&id=5b05e30f&"
import script from "./IconTextFile.vue?vue&type=script&lang=js&"
export * from "./IconTextFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b05e30f')) {
      api.createRecord('5b05e30f', component.options)
    } else {
      api.reload('5b05e30f', component.options)
    }
    module.hot.accept("./IconTextFile.vue?vue&type=template&id=5b05e30f&", function () {
      api.rerender('5b05e30f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconTextFile.vue"
export default component.exports